export const sortMenuListAll = [
    { text: 'Скинути', value: 'reset' },
    { text: 'A → Z', value: 'ASC' },
    { text: 'Z → A', value: 'DESC' },
    { text: '0 → 9', value: 'numberAsc' },
    { text: '9 → 0', value: 'numberDesc' },
    { text: 'Кастомне сортування', value: 'custom' },
]

export const getSortMenuList = ({ itemsNeeded }) => {
    try {
        const menuList = []

        if (itemsNeeded && itemsNeeded.length > 0) {
            for (const item of sortMenuListAll) {
                if (itemsNeeded.includes(item.value)) {
                    menuList.push(item)
                }
            }
        }

        return menuList
    } catch (e) {

    }
}